import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import TipoListaNcmService from 'business/cadastro/fiscal/tipoListaNcm/tipoListaNcmService'
import OutputSpanForm from 'base/OutputSpanForm'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'
import { formatDatetime } from 'helper/formater'

export default function TipoListaNcm() {

    const [service] = useState(() => new TipoListaNcmService())

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="codigo_tilin" form={form} service={service} type="text" clearString label="Código" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="descricao_tilin" form={form} service={service} type="text" clearString label="Descrição" />

                    </GridForm>

                </TabPanel>
                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm>
                        <OutputSpanForm field="dh_ins_tilin" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_ins_tilin'))} label="Inserção" />
                        <OutputSpanForm field="dh_atua_tilin" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_atua_tilin'))} label="Atualização" />
                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
